<template><UiButton class="lu-icon-button" :variant="variant" :disabled="disabled" :aria-label="label" :title="label" @click="$emit('click', $event)"><slot><UiIcon :name="icon" /></slot></UiButton></template>
<script>
import UiButton from './UiButton.vue'; import UiIcon from './UiIcon.vue';
export default { name:'UiIconButton', components:{UiButton,UiIcon}, props:{label:{type:String,required:true},icon:{type:String,default:'menu'},variant:{type:String,default:'ghost'},disabled:Boolean},emits:['click'] };
</script>
